import React from 'react';
import { Grid, Box, Typography, Button } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
// import { PRIMARY_GREEN, LIGHT_BG } from './theme/colors';
import { useT } from "contexts/TranslationContext";
const PRIMARY_GREEN = '#4CAF50';
const LIGHT_BG = '#E8F5E9';
// --- CTA Banner Component ---
const CTABanner = () => {
    const t = useT();
    return (
        <Grid container justifyContent="center" >
        <Box
            component="section"
            sx={{
                bgcolor: LIGHT_BG,
                py: { xs: 10, md: 16 }, // Vertical padding
                px: { xs: 4, sm: 8, lg: 16 },
                width: '100%',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            {/* Centered Content Box */}
            <Box
                sx={{
                    maxWidth: '900px', // Limiting the width for a tighter banner look
                    width: '100%',
                    p: { xs: 6, md: 8 },
                    borderRadius: '16px',
                    bgcolor: 'grey.50', // Very light background for contrast
                    textAlign: 'center',
                    border: '1px solid',
                    borderColor: 'grey.200',
                    boxShadow: 1,
                }}
            >
                {/* Title */}
                <Typography
                    variant="h4"
                    component="h2"
                    sx={{
                        fontWeight: 800,
                        color: 'grey.900',
                        mb: 2,
                        fontSize: { xs: '1.75rem', sm: '2rem' }
                    }}
                >
                    {t("cta.title")}
                </Typography>

                {/* Description */}
                <Typography
                    variant="body1"
                    sx={{
                        color: 'grey.700',
                        maxWidth: 600,
                        mx: 'auto',
                        mb: 4
                    }}
                >
                    {t("cta.subtitle")}
                </Typography>

                {/* CTA Button */}
                <Button
                    variant="contained"
                    size="large"
                    endIcon={<ChevronRightIcon />}
                    sx={{
                        bgcolor: PRIMARY_GREEN,
                        '&:hover': {
                            bgcolor: '#2d845e', // Darker green on hover
                            transform: 'scale(1.02)',
                            boxShadow: 4,
                        },
                        px: 4,
                        py: 1.5,
                        borderRadius: '8px',
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: 3,
                        transition: 'all 300ms ease',
                    }}
                    aria-label="Get started today"
                >
                    {t("cta.button")}
                </Button>
            </Box>
        </Box>
        </Grid>
    );
};
export default CTABanner;